/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
import { KeyboardEvent, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";

import { civilStoreNominal } from "../../../hooks/store";
import { useAuth } from "../../../hooks/auth";

import { LayoutConsultaCivil } from "./LayoutConsultaCivil";
import { ResultadoConsultaCivil } from "../../../components";

type InputProps = {
  nome: string | undefined;
  nomeMae: string | undefined;
  nomePai: string | undefined;
};

export const FiltroCivilNominal: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      nome: "",
      nomeMae: "",
      nomePai: "",
    },
  });

  const { user } = useAuth();

  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 2 ? s.url : false;
  })[0];

  const {
    consultaCivilNominal,
    limparConsultaCivilNominal: limparConsultaCivil,
    mensagem,
    resultadoCivilNominal,
  } = civilStoreNominal((state) => state.civil);

  const pesquisaCivilNominal = (data: InputProps) => {
    consultaCivilNominal(
      url,
      data.nome === "" ? undefined : data.nome,
      data.nomeMae === "" ? undefined : data.nomeMae,
      data.nomePai === "" ? undefined : data.nomePai
    );
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  const { loading } = civilStoreNominal((state) => state.global);

  return (
    <LayoutConsultaCivil>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(pesquisaCivilNominal)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nome"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nomeMae"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome da mãe"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="nomePai"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o nome do pai"
                value={value}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<Icon.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>

        <MUI.Grid item xs={12} md={4} sm={4}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaCivil}
            disabled={loading}
            startIcon={<Icon.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoCivilNominal || mensagem ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoCivilNominal &&
            resultadoCivilNominal?.map((cidadao) => (
              <ResultadoConsultaCivil
                key={cidadao.NumeroPedido}
                infoName={cidadao.Nome}
                infoMae={cidadao.Mae}
                infoPai={cidadao.Pai}
                to={`consulta-civil/ficha-civil/${cidadao.NumeroPessoa}`}
              />
            ))) || <MUI.Typography variant="h6">{mensagem}</MUI.Typography>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaCivil>
  );
};
